import { useContext } from 'react';

import {
	aiAssistantContext,
	PodcastDetailsPendingReason,
} from '../../../../state/AIAssistantContextProvider';
import useScreenSize from '../../../../utils/useScreenSize';
import { ActiveView } from '../constants';

const useIsPodcastLoadingViewActive = (): boolean => {
	const { activeView, pendingPodcastDetailsReason } = useContext(aiAssistantContext);
	const { isXsScreen, isSmScreen } = useScreenSize();
	const isXsOrSmScreen = isXsScreen || isSmScreen;

	// GENERATION_FINISHED covers the window between the poll settling and the detail view
	// opening. Without it the left pane empties for that window and the layout collapses
	// to chat-only, which reads as the whole view flickering.
	const isPodcastPaneOccupied =
		activeView === ActiveView.PODCAST_LOADING ||
		pendingPodcastDetailsReason === PodcastDetailsPendingReason.GENERATION_FINISHED;

	return !isXsOrSmScreen && isPodcastPaneOccupied;
};

export default useIsPodcastLoadingViewActive;
